import React, { useEffect, useRef } from "react";

export const About = () => {
  const photoRef = useRef<HTMLDivElement>(null);
  const bioRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) =>
          e.target.classList.toggle("visible", e.isIntersecting)
        ),
      { threshold: 0.1 }
    );
    [photoRef, bioRef].forEach((r) => r.current && observer.observe(r.current));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="about-section">
      <div className="about-photo-wrap reveal" ref={photoRef}>
        <div className="about-photo-frame" />
        <img
          className="about-photo"
          src="/headshot_1k.jpg"
          alt="Patrick Cleary"
        />
      </div>
      <div className="about-bio reveal" ref={bioRef}>
        <p className="section-label">About</p>
        <h2>Builder of spatial tools &amp; civic tech</h2>
        <p>
          I design and build websites and interactive tools that make the{" "}
          <em>built environment easier to understand</em>. My work spans data
          visualization, mapping, and urban analytics — translating complex
          spatial data into accessible, human-centered interfaces.
        </p>
        <p>
          Previously a backend engineer at Amazon. Now building civic and urban
          tech products with mission-driven teams.
        </p>
      </div>
    </section>
  );
};
